'use client';

import { atomWithStorage } from 'jotai/utils';

const myRegNumberAtom = atomWithStorage<string | null>('myRegNumber', null);

export { myRegNumberAtom };
